<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-if="item" class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" @click="close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Editar Extra</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('Name') }">
								<label>Nombre</label>
								<input v-validate="'required'" v-model="item.name" name="Name" type="text" class="form-control">
								<small v-show="errors.has('Name')" class="form-text text-danger">
									{{ errors.first('Name') }}
								</small>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Valor venta</label>
								<input v-model="item.sale_value" type="number" class="form-control">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Valor compra</label>
								<input v-model="item.purchase_value" type="number" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Descripción</label>
								<quill-editor v-model="item.description"
									ref="descriptionEditorEdit">
								</quill-editor>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnUpdate" @click="validate()" type="button" class="btn btn-success">Actualizar</button>
					<button type="button" class="btn btn-default" @click="close">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		data () {
			return {
				modal: {
					selector: 'modal-product-extras-edit',
				},

				item: null,
				originalItem: null,
			}
		},
		methods: {
			open(extra) {
				if(extra) {
					this.originalItem = extra
					this.item = Object.assign({}, extra)
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			validate(update) {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update: function() {
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				var api = null
				if(this.type == 'product') {
					api = 'admin/management/products/extras/' + this.item.id
				} else {
					if(this.type == 'productStorage') {
						api = 'admin/management/products/storages/extras/' + this.item.id
					}
				}
				this.$http.put(api, this.item)
					.then(response => {
						loading.stop()
						var extras = response.body.data
						this.data.extras = extras
						this.$emit('updated')
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
						this.close()
					}).catch(function(response) {
						console.log(response)
						loading.stop()
					})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/extras/views/Edit.vue